export default __webpack_public_path__ + "static/media/quickshot2.591414a8.png";